export const getBaseUrl = (url: string) => {
    return url.substring(0, url.lastIndexOf("."));
};
